import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { CanteenConnectCard } from '@/entities/canteen-connect'
import { Offcanvas } from '@/entities/offcanvas'
import { useSchoolCafeteriaItem } from '@/shared/api/school-cafeteria'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute(
  '/_auth/administration/reference-books/canteens/connects/$connectId'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()
  const { connectId } = Route.useParams()
  const { data: connect, isLoading, isError } = useSchoolCafeteriaItem(connectId)

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка связи')}>
      <CanteenConnectCard link={connect} isLoading={isLoading} isError={isError} />
    </Offcanvas>
  )
}
